"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiEmployeeLocationUnfollowResponse = instanceOfApiEmployeeLocationUnfollowResponse;
exports.ApiEmployeeLocationUnfollowResponseFromJSON = ApiEmployeeLocationUnfollowResponseFromJSON;
exports.ApiEmployeeLocationUnfollowResponseFromJSONTyped = ApiEmployeeLocationUnfollowResponseFromJSONTyped;
exports.ApiEmployeeLocationUnfollowResponseToJSON = ApiEmployeeLocationUnfollowResponseToJSON;
exports.ApiEmployeeLocationUnfollowResponseToJSONTyped = ApiEmployeeLocationUnfollowResponseToJSONTyped;
/**
 * Check if a given object implements the ApiEmployeeLocationUnfollowResponse interface.
 */
function instanceOfApiEmployeeLocationUnfollowResponse(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('success' in value) || value['success'] === undefined)
        return false;
    return true;
}
function ApiEmployeeLocationUnfollowResponseFromJSON(json) {
    return ApiEmployeeLocationUnfollowResponseFromJSONTyped(json, false);
}
function ApiEmployeeLocationUnfollowResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'success': json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}
function ApiEmployeeLocationUnfollowResponseToJSON(json) {
    return ApiEmployeeLocationUnfollowResponseToJSONTyped(json, false);
}
function ApiEmployeeLocationUnfollowResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'success': value['success'],
        'message': value['message'],
    };
}
